/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @public
 */
export var SummaryCompressionAlgorithm;
(function (SummaryCompressionAlgorithm) {
    SummaryCompressionAlgorithm[SummaryCompressionAlgorithm["None"] = 0] = "None";
    SummaryCompressionAlgorithm[SummaryCompressionAlgorithm["LZ4"] = 1] = "LZ4";
})(SummaryCompressionAlgorithm || (SummaryCompressionAlgorithm = {}));
export const DefaultCompressionStorageConfig = {
    algorithm: SummaryCompressionAlgorithm.LZ4,
    minSizeToCompress: 500,
};
//# sourceMappingURL=compressionTypes.js.map